module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Esther-aquarel-watercolor-tekening-meisje-digitaal-drukwerk-doopsuiker-2.8b5d808a.jpg";